import logo from "../images/logo.png";
export const BASE_URL_METABUDDY = process.env.REACT_APP_BASE_URL_METABUDDY;

// for apis
export const BASE_URL_API = process.env.REACT_APP_BASE_URL_API;

// for web pages
export const BASE_URL_COMPETITION = process.env.REACT_APP_BASE_URL_COMPETITION;

// for images etc
export const BASE_URL_MEDIA = process.env.REACT_APP_BASE_URL_MEDIA;

// for mobile api images etc
// export const BASE_URL_MEDIA_MOBILE_APIS =
//   "https://www.metaversebuddy.co/mobileapis";

// for navigation to trainer portal
export const BASE_URL_TRAINER = process.env.REACT_APP_BASE_URL_TRAINER;

// fot corporate name
export let CORPORATE_NAME = process.env.REACT_APP_CORPORATE_NAME;

export let CORPORATE_LOGO = logo;
